import api from './api'

export default {
    add(params) {
        return api.post('headerbanner', params)
    },
    async get(id) {
        const res = await api.fetch(`headerbanner/${id}`)
        return res
    },
    async list(params) {
        const res = await api.fetch('headerbanner', params)
        return res
    },
    update(params) {
        return api.patch('headerbanner', params)
    },
    delete(id) {
        return api.remove('headerbanner', id)
    }
}